import { ExperimentsBag } from '@wix/wix-experiments';

export function isExperimentEnabled(
  bag: ExperimentsBag,
  name: string,
): boolean {
  return bag[name] === 'true';
}
